import { api } from '../api/client.js';

// Milníky a pevné body (JCH-Milniky). Talks to /api/v1/milestones.
//
// Backend: GET /milestones/jch → { milestones, count } (JCH pending backlog),
// GET /milestones/jch/done → { milestones, count } (JCH-finished). Confirming
// the call is PATCH /:id/confirm with { role: 'JCH' }, scheduling the osobní
// setkání is POST /:id/meeting. All milestone responses are camelCase via
// buildMilestone (maklerName, milestoneType, jchConfirmed, meetingScheduled,
// createdAt). Confirming must send role='JCH' or the server rejects the request.

export function listJchPendingMilestones(query = {}) {
  return api
    .get('/milestones/jch', { params: query })
    .then((r) => r.data.data);
}

export function listJchDoneMilestones(query = {}) {
  return api
    .get('/milestones/jch/done', { params: query })
    .then((r) => r.data.data);
}

// Confirm the JCH has made the call. `role` drives which side's confirmation
// is written — JCH here.
export function confirmMilestone(id, role = 'JCH') {
  return api
    .patch(`/milestones/${id}/confirm`, { role })
    .then((r) => r.data.data);
}

// Schedule the osobní setkání for a setkání-type milestone.
export function scheduleMeeting(id, note = '') {
  return api
    .post(`/milestones/${id}/meeting`, { note })
    .then((r) => r.data.data);
}

// JR: everything still pending across the section.
export function listSectionMilestones(query = {}) {
  return api.get('/milestones/section', { params: query }).then((r) => r.data.data);
}
